import { reducer as refreshCounter } from './refreshCounter';
import { reducer as dashboardVariant } from './dashboardVariant';
import { reducer as user } from './user';
import { reducer as dashboardTab } from './dashboardTab';
import { reducer as eventEmitter } from './eventEmitter';

export const allReducers = {
    refreshCounter,
    eventEmitter,
    dashboardVariant,
    user,
    dashboardTab
};